import React from 'react'

import { ProductV2 } from '@common'
import cx from 'classnames'

import { useGames } from '@/features/common/useGames'
import ProductCard from '@/features/products/ProductCard'

import styles from './FeatureModule.module.scss'

interface FeatureModuleProps {
  title?: string | undefined
  products: ProductV2[]
  className?: string | string[]
}

export const FeatureModule: React.FC<FeatureModuleProps> = ({ products, className, title }) => {
  const games = useGames()
  return (
    <div className={cx(styles.FeatureModule, className)}>
      {title && <p className={styles.Title}>{title}</p>}
      <div className={styles.Container}>
        {products?.map((product) => {
          const game = games.find((g) => g.slug === product.game)
          if (!game) return
          return <ProductCard type={'Feature'} game={game} key={product.id} product={product} />
        })}
      </div>
    </div>
  )
}
